module.exports = __webpack_public_path__ + "img/Orangenminze_Feld.0a2d0700.jpg";